import React, { FunctionComponent } from 'react';
import urlJoin from 'url-join';
import { getSrc } from 'gatsby-plugin-image';

import { useSiteMetadata } from '../../hooks/useSiteMetadata';
import { SEOProps } from './types';

export const SEO: FunctionComponent<SEOProps> = ({ pathname, pageMetadata }) => {
  const { title: defaultTitle, language: defaultLanguage, siteUrl } = useSiteMetadata();

  const title = pageMetadata?.title || defaultTitle;
  const description = pageMetadata?.description;
  const keywords = pageMetadata?.keywords;
  const imageUrl = pageMetadata?.image ? getSrc(pageMetadata?.image) : undefined;
  const language = pageMetadata?.language || defaultLanguage;
  const url = urlJoin(siteUrl, pathname);
  const type = pageMetadata?.type || 'website';

  return (
    <>
      {language && <html lang={language} />}
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && keywords.length > 0 && <meta name="keywords" content={keywords.join(', ')} />}
      {title && <meta property="og:title" content={title} />}
      {url && <meta property="og:url" content={url} />}
      {description && <meta property="og:description" content={description} />}
      {type && <meta property="og:type" content={type} />}
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      {imageUrl && title && <meta property="og:image:alt" content={title} />}
      {imageUrl && <meta name="twitter:card" content="summary_large_image" />}
      <meta name="format-detection" content="telephone=no" />
    </>
  );
};
